import { Component } from '@angular/core';
import { SessionService } from '../service/session.service';
import { WindowService } from '../../../services/window.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { concatMap } from 'rxjs/operators';
import { GemsService } from 'client/app/shared/services';

@Component({
  selector: 'app-session-expiration-dialog',
  templateUrl: 'session-expiration-dialog.component.html',
  styleUrls: ['session-expiration-dialog.component.less'],
  standalone: false
})
export class SessionExpirationDialogComponent {
  tick: any;

  constructor(
    private sessionService: SessionService,
    private bsModalRef: BsModalRef,
    private gemsService: GemsService
  ) {
    sessionService.countdown$.subscribe(tick => {
      this.tick = this.formatTime(tick);
    });

    sessionService.timeout$.pipe(
      concatMap(() => this.gemsService.siteMap())
    ).subscribe(sitemap => {
      this.bsModalRef.hide();
      WindowService.getNativeWindow().location.href = sitemap.logout_url;
    });

    sessionService.idleEnded$.subscribe(status => {
      // this.close();
    });
  }

  keepMeLoggedIn() {
    this.sessionService.keepMeLoggedIn();
    this.bsModalRef.hide();
  }

  formatTime(tick: number) {
    let minutes: any = Math.floor(tick / 60);
    let seconds: any = tick % 60;

    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    return minutes + ':' + seconds;
  }
}
